import React, { useEffect, useRef, useState } from 'react';
import type { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import { Select, Spin, Table, Tooltip, notification } from 'antd';
import { deleteWorkOrder, fetchSOWDetails, fetchSOWandClient, fetchWorkOrderList, setPOMappingModalIsOpen, setWorkOrderModalIsOpen, setWorkOrderSelectedSOW, triggerParentId } from '../../store/reducers/orderDashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import { isSOWEndDateUpdated, rejectedApiMessage } from '../../utilities/CommonHelper';
import FloatLabel from '../../components/FloatLabel/floatLabel';
import DataTable from '../../components/DataTable/DataTable';
import moment from 'moment';
import WorkOrderAuditLog from '../WorkOrderAuditLog/workOrderAuditLog';
import { InfoCircleTwoTone } from '@ant-design/icons';

interface Props {
 _selectedSOWDetails: any;
 activeTab: string;
 refreshTable: boolean;
 handleRefreshTable: (value: boolean) => void;
}
interface DataType {
 key: React.Key;
 orderId: string;
 clientEntity: string;
 bu: string;
 department: string;
 parentId: string;
 indegeneEntity: string;
}
const form_fields: {
 label: string;
 placeholder: string;
 id: string;
 required: boolean;
 disabled: boolean,
 options?: { label: string, value: string }[];
 type: 'textbox' | 'selectDropdown' | 'multilineTextbox'
}[] = [
   {
     label: 'Client Name ',
     placeholder: 'Indegene',
     id: 'clientEntity',
     required: true,
     disabled: false,
     type: 'selectDropdown',
     options: [{ label: 'Something1', value: 'something1' }, { label: 'Something2', value: 'Something2' }, { label: 'Something3', value: 'Something3' }, { label: 'Something 4', value: 'Something4' }, { label: 'Something 5', value: 'Something5' }]

   },
   {
     label: 'SOW ',
     placeholder: 'Enter BU',
     id: 'BuName',
     required: true,
     disabled: false,
     type: 'selectDropdown',
     options: [{ label: 'Something1', value: 'something1' }, { label: 'Something2', value: 'Something2' }, { label: 'Something3', value: 'Something3' }, { label: 'Something 4', value: 'Something4' }, { label: 'Something 5', value: 'Something5' }]

   }
 ]
const data: DataType[] = [];
for (let i = 0; i < 100; i++) {
  data.push({
   key: i,
   orderId: `Map Opportunity to create work Order ID ${i}`,
   clientEntity: `Map Opportunity to clientEntity ID ${i}`,
   bu: `bu ${i}`,
   department: `department ${i}`,
   parentId: `parentId ${i}`,
   indegeneEntity: `indegeneEntity ${i}`
  });
}

  
const Workordertab: React.FC<Props> = ({_selectedSOWDetails,activeTab, refreshTable, handleRefreshTable}) => {
const dispatch = useDispatch();
const orderDashboardData = useSelector((state: any) => state.orderDashboard);
 const [isPOModalOpen, setIsPOModalOpen] = useState(false);
 const [clientEntityList, setClientEntityList] = useState<any>([]);
 const [selectedClientEntity, setSelectedClientEntity] = useState<any>("");
 const [sowIdList, setSowIdList] = useState<any>([]);
 const [selectedSowId, setSelectedSowId] = useState<any>("");
 const [selectedSOWDetails, setSelectedSOWDetails] = useState<any>({});
 const [workorderDataList, setWorkorderDataList] = useState<any>([]);
 const [clientSOWDataList, setClientSOWDataList] = useState<any>([]);
 const [pageNo, setPageNo] = useState<number>(0);
 const [pageSize, setPageSize] = useState<number>(10);
 const [totalCount, setTotalCount] = useState<number>(0);
 const [selectedWorkOrder, setSelectedWorkOrder] = useState<any>({});
 const [viewAuditlogModal, setViewAuditlogModal] = useState<boolean>(false);
 const selectRef = useRef<any>(null);

 const handleChangedValue = (id:any,value: any) => {
  selectRef.current.blur();
  if(id==='clientEntity'){
    setSelectedClientEntity(value);
    console.log("selectedSowId",value);
    setSowIdList(clientSOWDataList[value]);
    setSelectedSowId("");
    dispatch(setWorkOrderSelectedSOW({}));
  }
  if(id==='sowId'){
    setSelectedSowId(value);
    console.log("selectedSowId",value);
    console.log("selectedClientEntity",selectedClientEntity);
    fetchworkOrderData(selectedClientEntity,value);
    dispatch(fetchSOWDetails({sowId:value})).then((response: any) => {
      if (response.type !== 'orderDashboard/fetchSOWDetails/fulfilled') {
        rejectedApiMessage(response.payload);
      }
      else{
        setSelectedSOWDetails(response.payload);
        dispatch(setWorkOrderSelectedSOW(response.payload));
      }
    });
  }
  console.log(id,value);
}

const fetchworkOrderData=(ClientEntity:any,sowID:any)=>{
  console.log("fetchworkOrderData",ClientEntity,sowID);  
  dispatch(fetchWorkOrderList({clientName:ClientEntity,sowId:sowID,page:pageNo,size:pageSize})).then((response: any) => {
    if (response.type !== 'orderDashboard/fetchWorkOrderList/fulfilled') {
      rejectedApiMessage(response.payload);
    }
    else{
      let temp : any[]= response.payload.content;      
      temp = temp.sort((a:any, b:any) => moment(b.lastModifiedDate, 'YYYY-MM-DD').diff(moment(a.lastModifiedDate, 'YYYY-MM-DD')))
      setWorkorderDataList(temp);
      setPageNo(0);

    }
  });
}
  const showPOModal = () => {
   setIsPOModalOpen(true);
  }
  useEffect(() => {
    if(activeTab === '2'){

    console.log(_selectedSOWDetails);
      if(Object.keys(_selectedSOWDetails).length > 0){
        setSelectedSOWDetails(_selectedSOWDetails);
        setSelectedClientEntity(_selectedSOWDetails.clientEntity);
        setSelectedSowId(_selectedSOWDetails.sowId);
        fetchworkOrderData(_selectedSOWDetails.clientEntity,_selectedSOWDetails.sowId);
      }
      dispatch(fetchSOWandClient()).then((response: any) => {
        if (response.type !== 'orderDashboard/fetchSOWandClient/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else{
          setClientSOWDataList(response.payload);
          setClientEntityList(Object.keys(response.payload));
          if(Object.keys(_selectedSOWDetails).length > 0){
            setSowIdList(response.payload[_selectedSOWDetails.clientEntity]);
          }
          // setSowIdList(response.payload.sowIdList);
        }
      })
      
      

    }
    else{
      setSelectedSOWDetails({});
      setSelectedClientEntity("");
      setSelectedSowId("");
      setWorkorderDataList([]);
      setClientSOWDataList([]);
      setClientEntityList([]);
      setSowIdList([]);
      setPageNo(0);
      setPageSize(10);
      setTotalCount(0);
    }

  },[_selectedSOWDetails,activeTab,]);

  useEffect(() => {
    dispatch(fetchSOWandClient()).then((response: any) => {
      if (response.type !== 'orderDashboard/fetchSOWandClient/fulfilled') {
        rejectedApiMessage(response.payload);
      }
      else{
        setClientSOWDataList(response.payload);
        setClientEntityList(Object.keys(response.payload));
        if(Object.keys(_selectedSOWDetails).length > 0){
          setSowIdList(response.payload[_selectedSOWDetails.clientEntity]);
        }
        // setSowIdList(response.payload.sowIdList);
      }
    })
  },[setClientEntityList, setSowIdList, setClientSOWDataList])
  useEffect(() => {
    console.log("refreshTable",refreshTable);
    console.log(_selectedSOWDetails);
    if(refreshTable){
      handleRefreshTable(false);
      fetchworkOrderData(selectedClientEntity,selectedSowId);
    }
  },[refreshTable]);

  const clientEntity = [{ label: 'Something1', value: 'something1' }, { label: 'Something2', value: 'Something2' }, { label: 'Something3', value: 'Something3' }, { label: 'Something 4', value: 'Something4' }, { label: 'Something 5', value: 'Something5' }]
  const columns: ColumnsType<DataType> = [
   {
     title: 'Work Order ID',
     width: 150,
     dataIndex: 'id',
     key: 'id',
     fixed: 'left',
   },
   {
     title: 'Client Entity',
     width: 150,
     dataIndex: 'clientEntity',
     key: 'clientEntity',
   },
   {
    title: 'Indegene Entity',
    dataIndex: 'indegeneEntity',
    key: 'indegeneEntity',
    width: 150,
  },
   {
     title: 'BU',
     dataIndex: 'bu',
     key: 'bu',
     width: 150,
     render: (text: string, record: any) => {
      if(record?.workOrderBuDepartments?.length>0)
      return(<>{
        record?.workOrderBuDepartments?.map((item:any)=><><span>{item.bu}</span><br/></>)}

      </>)
     },
   },
   {
     title: 'Department',
     dataIndex: 'department',
     key: 'department',
     width: 150,
     render: (text: string, record: any) => {
      if(record?.workOrderBuDepartments?.length>0)
      return(<>{
        record?.workOrderBuDepartments?.map((item:any)=><><span>{item.department}</span><br/></>)}

      </>)
     },
   },
   {
    title: 'Sub Department',
    dataIndex: 'subDepartment',
    key: 'subDepartment',
    width: 150,
    render: (text: string, record: any) => {
     if(record?.workOrderBuDepartments?.length>0)
     return(<>{
       record?.workOrderBuDepartments?.map((item:any)=><><span>{item.subDepartment}</span><br/></>)}

     </>)
    },
  },
   {
     title: 'Parent Id',
     dataIndex: 'parentId',
     key: 'parentId',
     width: 150,
   },
   
   {
     title: 'PO',
     fixed: 'right',
     width: 150,
     render: () => <a className='maplink' onClick={showPOModal}>Map PO LINK</a>,
   },
 ];

 const handleTableChange = (pagination: TablePaginationConfig) => {
  const { current, pageSize } = pagination;
  setPageNo(current ? current - 1 : 0);
  setPageSize(pageSize || 10);
};

const handleEditWorkOrder= (row:any) => {
  console.log("handleEditWorkOrder starting",row);
      dispatch(setWorkOrderModalIsOpen({isModalOpen:true,selectedWorkOrder:row,type:'edit'}));
    
}
const handleDeleteWorkOrder =(row:any) => {
  // console.log("handleDeleteWorkOrder",row);

      dispatch(deleteWorkOrder({workOrderId:row.id})).then((response: any) => {
        if (response.type !== 'orderDashboard/deleteWorkOrder/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else{
          notification.success({message: 'Success', description:'Work Order Deleted Successfully.'})
          fetchworkOrderData(selectedClientEntity,selectedSowId);
      
        }
      });
  
}
const handleMapUnmapPO =(row:any) => {

  dispatch(setPOMappingModalIsOpen({isModalOpen:true,selectedWorkOrder:row}));
  
  
}

const handleParentIdTrigger =(row:any) => {

  dispatch(triggerParentId({workOrderId:row.id})).then((response: any) => {
    if (response.type !== 'orderDashboard/triggerParentId/fulfilled') {
      rejectedApiMessage(response.payload);
      fetchworkOrderData(selectedClientEntity,selectedSowId);
    }
    else{
      notification.success({message: 'Success', description:'Parent Id Generated Successfully.'})
      fetchworkOrderData(selectedClientEntity,selectedSowId);
    }
  });
  
}

const handleWorkOrderHistory =(row:any) => {
  setSelectedWorkOrder(row);
  setViewAuditlogModal(true)
}

  return (
        <Spin spinning={orderDashboardData?.loading} tip="Loading..."><div>

<div 
// style={{ background: '#F2F6FA', margin: '15px', padding: '15px' }}
>
      <div className="form-component" style={{ maxWidth: '100%' }}>
      <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
          <FloatLabel label="Client Entity" value={selectedClientEntity}> 
             {/* <AutoComplete
            id='clientEntity'
            size="middle"
            value={selectedClientEntity}
            onSelect={(value:string)=>handleChangedValue('clientEntity',value)}
            style={{ width: 400,height:58,marginRight:'10px' }}
            disabled={clientEntityList.length>0?false:true}
            options={clientEntityList.length>0?clientEntityList.map((item:any) => ({ value: item })):undefined}
            placeholder="Select Client Entity"
            filterOption={(inputValue:any, option:any) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            // required={field.required}
            /> */}
            <Select
              showSearch
              // allowClear
              size='middle'
              ref={selectRef}
              // style={{ width: 200 }}
              style={{ width: '100%',height:58,marginRight:'10px' }}
              placeholder="Select Client Name"
              optionFilterProp="children"
              value={selectedClientEntity}
              onSelect={(value:string)=>handleChangedValue('clientEntity',value)}
              
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              filterOption={(input:any, option:any) =>
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={clientEntityList.map((item:any) => ({ value: item }))}
          >
          </Select> 
        </FloatLabel>
        </div>
        <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn' style={{marginLeft:'30px'}}>
          <FloatLabel label="SOW ID" value={selectedSowId}>
            {/* <AutoComplete
            id='bu'
            size="middle"
            value={selectedBu}
            onSelect={(value:string)=>handleChangedValue('bu',value)}
            style={{ width: 400,height:58,marginRight:'10px' }}
            disabled={selectedClientEntity?false:true}
            placeholder="Select Business Unit"
            options={buList}
            filterOption={(inputValue, option) => option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            // required={field.required}
            /> */}
            <Select
              showSearch
              // allowClear
              size='middle'
              ref={selectRef}
              // style={{ width: 200 }}
              style={{ width: '100%',height:58,marginRight:'10px' }}
              placeholder="Select Business Unit"
              optionFilterProp="children"
              value={selectedSowId}
              disabled={selectedClientEntity?false:true}
              onSelect={(value:string)=>handleChangedValue('sowId',value)}
              
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              filterOption={(input:any, option:any) =>
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={sowIdList?.map((item:any) => ({ value: item,label:item })) || []}
          >
          </Select> 
          </FloatLabel>
        </div>
        </div>
        { selectedSOWDetails.sowStartDate && <div style={{marginBottom:'10px'}}>
          <span className='maplink'>SOW Duration : </span>
          <span className='maplink' >{selectedSOWDetails.sowStartDate} - {selectedSOWDetails.sowEndDate}</span> &nbsp;
          {
            isSOWEndDateUpdated(selectedSOWDetails.sowEndDate, selectedSOWDetails.originalSowEndDate) && 
            <Tooltip title={`SOW end date updated from ${selectedSOWDetails.originalSowEndDate} to ${selectedSOWDetails.sowEndDate} due to CRF/Amendment Tagging. Please Click on "View Tagged SOW" in SOW Dashboard to view the CRF/Amendment.`}>
              <InfoCircleTwoTone />
              </Tooltip>
          }
          </div>}
        {/* <Table columns={columns}
        className='table-style'
         dataSource={workorderDataList}
        //  dataSource={data}
         loading={orderDashboardData?.loading}
         rowKey={'orderId'}
         pagination={{
          current: pageNo + 1,
          pageSize,
          total: totalCount,
        }}
				onChange={handleTableChange}
          scroll={{ x: 'max-content' }} /> */}
          <DataTable
          handleDeleteWorkOrder={(row:any) => handleDeleteWorkOrder(row)}
          // openLinkModal={(row) => this.setState({ isLinkModalVisible: true, selectedRow: row })} 
          // openParentIdDModal={(row) => this.setState({ parentDetailsvisible: true, selectedRow: row })} 
          handleEditWorkOrder={(row:any) => handleEditWorkOrder(row)}
          handleMapUnmapPO={(row:any) => handleMapUnmapPO(row)}
          handleParentIdTrigger={(row:any) => handleParentIdTrigger(row)}
          handleWorkOrderHistory={(row:any) => handleWorkOrderHistory(row)}
          data={workorderDataList} />
      </div>

    </div>
    
   </div>
   <WorkOrderAuditLog visible={viewAuditlogModal} onCancel={()=>{setViewAuditlogModal(false); setSelectedWorkOrder({})}} selectedWorkOrder={selectedWorkOrder} />

    </Spin>
  );
};

export default Workordertab;
